import styled from '@emotion/styled';

import theme from './theme';

export default styled('a')`
  display: inline-block;
  border: 1px solid ${theme.colors.primary};
  padding: 0.1em 0.3em;
`;
